import { emailService } from "../services/emailService";

const buildEmail = (data, info) => {
  let fields = info.fields;
  if (fields && typeof fields[0] !== "string") {
    fields = fields.map(item => item.name.toLowerCase());
  }
  const content = fields.map(e => `<p>${e.toUpperCase()}: ${data[e.toLowerCase()]}</p>`).join("");
  const html = `<h1>${info.subject}</h1>${content}`;
  return html;
};

const sendEmail = async (data, info) => {
  const form = document.querySelector("form");
  let formData = new FormData(form);
  formData.append("from", info.from || info.emailFrom);
  formData.append("subject", info.subject);
  formData.append(
    "to",
    process.env.REACT_APP_BUILD_ENV === "production"
      ? info.to || info.emailTo
      : process.env.TEST_EMAIL || "emails-dev@speedoc.com"
  );
  formData.append("html", buildEmail(data, info));

  return await emailService(formData);
};

export default sendEmail;
